module.exports = __webpack_public_path__ + "img/sankaku_64_blue.7c81f500.png";